module.exports = __webpack_public_path__ + "static/media/caret-square-down.82a048f2.svg";